/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import Promise from 'bluebird';

import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
import { supportsFancyPeel } from '@trello/browser';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { CardFrontTestIds } from '@trello/test-ids';

import { stickerSize } from 'app/scripts/data/sticker-size';
import { Util } from 'app/scripts/lib/util';
import { stickerClip } from 'app/scripts/lib/util/sticker-clip';
import type { Card } from 'app/scripts/models/Card';
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
import { View } from 'app/scripts/views/internal/View';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

import residuePng from 'resources/images/stickers/residue.png';
const t = teacupWithHelpers('sticker_on_card');

const HOVER_WAIT_MS = 350;
const REMOVE_WAIT_MS = 200;
const OVERLAP_PX = 8;

// eslint-disable-next-line @trello/no-module-logic
const USE_FANCY_PEEL = supportsFancyPeel();

// eslint-disable-next-line @trello/no-module-logic
const template = t.renderable(function ({
  url,
  rotate,
  image,
  showEditControls,
  showRemoveUI,
  isGiphySticker,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  if (showRemoveUI) {
    t.div(
      {
        class: t.classify({
          'sticker-removing': true,
          'giphy-sticker': isGiphySticker,
        }),
      },
      function () {
        t.div('.sticker-removing-highlight', {
          style: `transform: rotate(${rotate}deg)`,
        });
        if (USE_FANCY_PEEL) {
          t.img('.sticker-remove-image.sticker-removing-residue', {
            src: residuePng,
            style: `--sticker-rotation: ${rotate}deg; mask-image: ${t.urlify(
              url,
            )}; -webkit-mask-image: ${t.urlify(url)};`,
          });
          t.img('.sticker-remove-image.sticker-removing-shadow', {
            src: url,
            style: `--sticker-rotation: ${rotate}deg`,
          });
          t.img('.sticker-remove-image.sticker-removing-fixed', {
            src: url,
            style: `--sticker-rotation: ${rotate}deg;`,
          });
          return t.img('.sticker-remove-image.sticker-removing-peel', {
            src: url,
            style: `--sticker-rotation: ${rotate}deg`,
          });
        } else {
          return t.img('.sticker-remove-image.sticker-removing-fixed', {
            src: url,
            style: `transform: rotate(${rotate}deg)`,
          });
        }
      },
    );

    return t.span(
      '.sticker-control-btn.remove-btn.js-remove-sticker',
      { style: 'display: none' },
      () => t.format('remove'),
    );
  } else {
    t.img({
      class: t.classify({
        'sticker-image': true,
        'giphy-sticker': isGiphySticker,
      }),
      src: url,
      style: `-webkit-transform: rotate(${rotate}deg);transform: rotate(${rotate}deg);`,
      alt: image,
    });
    if (showEditControls) {
      return t.div('.sticker-controls', function () {
        return t.span('.sticker-control-btn.remove-btn.js-remove-sticker', () =>
          t.format('remove'),
        );
      });
    }
  }
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const measure = function (el: any, options: any) {
  if (options == null) {
    options = {};
  }
  const rect = el.getBoundingClientRect();

  const { left } = rect;
  const { top } = rect;
  const right = options.fixedWidth ? left + options.fixedWidth() : rect.right;
  const bottom = options.fixedHeight
    ? top + options.fixedHeight()
    : rect.bottom;
  return {
    left,
    top,
    bottom,
    right,
    width: right - left,
    height: bottom - top,
    x: left + (right - left) / 2,
    y: top + (bottom - top) / 2,
  };
};

function getPositiveDegrees(y: number, x: number) {
  return (Util.getDegrees(y, x) + 360) % 360;
}

// Find the best position for a control so that it
// - Is near the item being operated on (rect)
// - Is fully contained in a container (containerRect)
// - Is far from where the cursor is currently headed
const getOptimalRemovePosition = function ({
  rect,
  containerRect,
  controlRect,
  currentX,
  currentY,
  deltaX,
  deltaY,
  interval,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  const angle = getPositiveDegrees(-deltaY, deltaX);

  // We want to avoid some placements if they look like they're in the direction
  // the mouse is headed
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const near = (avoidAngle: any) =>
    avoidAngle - 45 < angle && angle < avoidAngle + 45;

  const yTop = -controlRect.height + OVERLAP_PX;
  const yMiddle = (rect.height - controlRect.height) / 2;
  const yBottom = rect.height - OVERLAP_PX;

  const xLeft = -controlRect.width + OVERLAP_PX;
  const xMiddle = (rect.width - controlRect.width) / 2;
  const xRight = rect.width - OVERLAP_PX;

  const potentialPositions = [
    // South
    {
      left: xMiddle,
      top: yBottom,
      avoid: near(270),
    },
    // North
    {
      left: xMiddle,
      top: yTop,
      avoid: near(90),
    },
    // East
    {
      left: xRight,
      top: yMiddle,
      avoid: near(0) || near(360),
    },
    // West
    {
      left: xLeft,
      top: yMiddle,
      avoid: near(180),
    },
    // Southwest
    {
      left: xLeft,
      top: yBottom,
      avoid: near(225),
    },
    // Southeast
    {
      left: xRight,
      top: yBottom,
      avoid: near(315),
    },
    // Northwest
    {
      left: xLeft,
      top: yTop,
      avoid: near(135),
    },
    // Northeast
    {
      left: xRight,
      top: yTop,
      avoid: near(45),
    },
  ];

  const positionsWithVisibleArea = potentialPositions
    .map((pos) => {
      const left = pos.left + (rect.left - containerRect.left);
      const top = pos.top + (rect.top - containerRect.top);
      const right = left + controlRect.width;
      const bottom = top + controlRect.height;

      const area =
        (Math.min(right, containerRect.width) - Math.max(0, left)) *
        (Math.min(bottom, containerRect.height) - Math.max(0, top));

      return { ...pos, visibleArea: area };
    })
    .sort((a, b) => b.visibleArea - a.visibleArea);

  return (
    positionsWithVisibleArea.filter((pos) => !pos.avoid)[0] ||
    positionsWithVisibleArea.filter((pos) => pos.avoid)[0] ||
    positionsWithVisibleArea[0]
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let removeRect: any = null;

// @ts-expect-error TS(2430): Interface 'StickerView' incorrectly extends interf... Remove this comment to see the full error message
interface StickerView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentX: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentY: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hoverTimeout: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeTimeout: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  requestAnimationFrame: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setTimeout: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showRemoveUI: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showingRemove: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  startX: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  startY: any;
}

class StickerView extends View {
  static initClass() {
    // @ts-expect-error TS(2322): Type 'string' is not assignable to type '() => str... Remove this comment to see the full error message
    this.prototype.className = 'sticker';
  }

  initialize() {
    super.initialize(...arguments);

    return this.listenTo(this.model, 'change', this.render);
  }

  showEditControls() {
    return false;
  }

  attributes() {
    return {
      'data-testid': CardFrontTestIds.Sticker,
    };
  }

  // @ts-expect-error TS(2416): Property 'events' in type 'StickerView' is not ass... Remove this comment to see the full error message
  events() {
    if (!this.options.canRemove) {
      return {};
    }

    return {
      // @ts-expect-error TS(7023): 'mouseenter' implicitly has return type 'any' beca... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      mouseenter(e: any) {
        // @ts-expect-error TS(2339): Property 'showRemoveUI' does not exist on type '{ ... Remove this comment to see the full error message
        if (!this.showRemoveUI) {
          // @ts-expect-error TS(2339): Property 'showRemoveUI' does not exist on type '{ ... Remove this comment to see the full error message
          this.showRemoveUI = true;
          // @ts-expect-error TS(2339): Property 'render' does not exist on type '{ mousee... Remove this comment to see the full error message
          return this.render();
        }
      },

      mouseleave: 'mouseLeave',
      mousemove: 'mouseMove',
      // @ts-expect-error TS(7023): 'mousedown' implicitly has return type 'any' becau... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      mousedown(e: any) {
        // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ mouseente... Remove this comment to see the full error message
        if (!$(e.target, this.$el).closest('.js-remove-sticker').length) {
          // @ts-expect-error TS(2339): Property 'removeRemove' does not exist on type '{ ... Remove this comment to see the full error message
          return this.removeRemove();
        }
      },
      'left-sticker': 'removeRemove',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      'mousemove .js-remove-sticker'(e: any) {
        // Don't let the outer mouseMove handler get this; it'll
        // cancel a click on the remove button if the cursor moves
        // a little while the mouse is down
        return stopPropagationAndPreventDefault(e);
      },

      // @ts-expect-error TS(7023): ''mouseenter .js-remove-sticker'' implicitly has r... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      'mouseenter .js-remove-sticker'(e: any) {
        // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ mouseente... Remove this comment to see the full error message
        return this.$el.addClass('peeling');
      },

      // @ts-expect-error TS(7023): ''mouseleave .js-remove-sticker'' implicitly has r... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      'mouseleave .js-remove-sticker'(e: any) {
        // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ mouseente... Remove this comment to see the full error message
        return this.$el.removeClass('peeling');
      },

      // @ts-expect-error TS(7023): ''click .js-remove-sticker'' implicitly has return... Remove this comment to see the full error message
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      'click .js-remove-sticker'(e: any) {
        stopPropagationAndPreventDefault(e);
        // @ts-expect-error TS(2339): Property 'removeSticker' does not exist on type '{... Remove this comment to see the full error message
        return this.removeSticker();
      },
    };
  }

  render() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data: any = this.model.toJSON();
    data.url =
      Util.smallestPreviewBiggerThan(data.imageScaled, stickerSize)?.url ??
      data.imageUrl;
    data.showEditControls = this.showEditControls();
    data.showRemoveUI = this.showRemoveUI;

    this.$el.html(template(data)).css({
      left: `${stickerClip(data.left)}%`,
      top: `${stickerClip(data.top)}%`,
    });

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mouseMove(e: any) {
    if (e.buttons) {
      return this.removeRemove();
    } else if (this.showingRemove) {
      return this.clearTimeouts();
    } else if (this.hoverTimeout) {
      this.currentX = e.offsetX;
      return (this.currentY = e.offsetY);
    } else {
      this.$el.siblings().trigger('left-sticker');

      this.currentX = this.startX = e.offsetX;
      this.currentY = this.startY = e.offsetY;

      return (this.hoverTimeout = this.setTimeout(() => {
        return this.showRemove();
      }, HOVER_WAIT_MS));
    }
  }

  showRemove() {
    if (this.showingRemove) {
      return;
    }
    this.showingRemove = true;

    const deltaX = this.currentX - this.startX;
    const deltaY = this.currentY - this.startY;
    this.$el.addClass('hover');

    // eslint-disable-next-line @trello/enforce-variable-case
    const $removeSticker = $('.js-remove-sticker', this.$el);

    return Promise.try(() => {
      // HACK: Get the dimensions of the "remove sticker" button
      if (removeRect) {
        return removeRect;
      }

      $removeSticker.css({ display: 'inline-block' });
      return new Promise((resolve) => {
        return this.requestAnimationFrame(() => {
          // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
          removeRect = measure($removeSticker.get(0));
          $removeSticker.css({ display: 'none' });
          return resolve(removeRect);
        });
      });
    })
      .then((controlRect) => {
        const stickersArea = this.$el.closest('.js-stickers-area').get(0);
        if (!stickersArea) {
          // We assume that the StickerView has been placed inside an element
          // with the js-stickers-area class, but it's possible that our parent
          // has been removed from the DOM and we're still running scheduled
          // callbacks because the removal of this StickerView is still pending
          // in the subview removal queue.  If we can't find the expected
          // container, we can bail
          return;
        }

        const { left, top } = getOptimalRemovePosition({
          // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
          rect: measure(this.el),
          containerRect: measure(stickersArea, {
            fixedWidth: this.options.fixedWidth,
            fixedHeight: this.options.fixedHeight,
          }),

          controlRect,
          currentX: this.currentX,
          currentY: this.currentY,
          deltaX,
          deltaY,
          interval: HOVER_WAIT_MS,
        });

        return $removeSticker.css({
          display: 'inline-block',
          top,
          left,
        });
      })
      .done();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeRemove(e?: any) {
    if (!this.showingRemove) {
      return;
    }
    this.showingRemove = false;

    this.clearTimeouts();

    $('.js-remove-sticker', this.$el).css({ display: 'none' });
    return this.$el.removeClass('hover peeling');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mouseLeave(e: any) {
    this.clearTimeouts();

    return (this.removeTimeout = this.setTimeout(() => {
      return this.removeRemove();
    }, REMOVE_WAIT_MS));
  }

  clearTimeouts() {
    clearTimeout(this.hoverTimeout);
    this.hoverTimeout = null;
    clearTimeout(this.removeTimeout);
    return (this.removeTimeout = null);
  }

  removeSticker() {
    const traceId = Analytics.startTask({
      taskName: 'edit-card/stickers',
      source: 'stickerHoverView',
      attributes: {
        action: 'removed',
      },
    });

    this.clearTimeouts();
    this.$el.remove();
    return this.model.destroyWithTracing(
      {
        traceId,
      },
      tracingCallback(
        {
          taskName: 'edit-card/stickers',
          traceId,
          source: 'stickerHoverView',
          attributes: {
            action: 'removed',
          },
        },
        (_err, sticker) => {
          if (sticker) {
            const card = this.options?.card as Card;
            Analytics.sendUpdatedCardFieldEvent({
              field: 'stickers',
              source: 'stickerHoverView',
              attributes: {
                taskId: traceId,
                action: 'removed',
              },
              containers: {
                card: {
                  id: card?.id,
                },
                list: {
                  id: card?.get('idList'),
                },
                board: {
                  id: card?.get('idBoard'),
                },
              },
            });
          }
        },
      ),
    );
  }
}

StickerView.initClass();
export { StickerView };
